import { bulkResizeSelector } from "store/features/bulkResize/selectors/bulkResizeSelector";
import { BulkResizeState } from "store/features/bulkResize/types";
import { setDPI } from "store/features/bulkResize/actions";
import { useAppSelector, useAppDispatch } from "store/store";
import { DPI } from "store/types/dpi";

export const useDPI = () => {
    const {
        resizeSettings: { dpi },
    } = useAppSelector(bulkResizeSelector, equalityFn);
    const dispatch = useAppDispatch();

    const handleChange = (option: DPI) => dispatch(setDPI(option));

    return {
        dpi,
        handleChange,
    };
};

const equalityFn = (
    left: BulkResizeState,
    right: BulkResizeState
) => {
    if (left.resizeSettings.dpi !== right.resizeSettings.dpi) return false;

    return true;
};
